import axios from '../../config/axios';
import config from '../../config/api';
import { setSnackbar } from './SnackbarAction';
import { fetchMerchantByPOSClientID } from './MerchantActions';

export const getAllPOSClients = (data) => ({
    type: 'GET_POS_CLIENTS',
    data
})

export const getPOSClientData = (data) => ({
    type: 'GET_POS_CLIENT',
    data
})

export const getFilteredData = (data) => ({
    type: 'FILTER_POS_CLIENTS',
    data
})

export const setEdited = (data) => ({
    type: 'SET_EDIT',
    data
})

export const setModified = (data) => ({
    type: 'SET_MODIFIED',
    data
})

export const setPOSClientID = (data) => ({
    type: 'SET_POS_CLIENTID',
    data
})


export const fetchAllPOSClients = () => {

    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/posClient/getAllPOSClients`).then(response => {
            if (response.status === 200) {
                dispatch(getAllPOSClients(response.data));
            } else {
                dispatch(getAllPOSClients([]));
            }
        }).catch(error => {
            dispatch(getAllPOSClients([]));
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
        })
    }
}

export const fetchPOSClient = (clientID) => {
    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/posClient/getPOSClientInfo/${clientID}`).then(response => {
            if (response.status === 200) {
                dispatch(getPOSClientData([response.data]));
            } else {
                dispatch(getPOSClientData([]));
            }
        }).catch(error => {
            dispatch(getPOSClientData([]));
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
        })
    }
}

export const addPOSClient = (body) => {
    return function (dispatch) {
        axios.post(`${config.api.FETCH_URL}/posClient/addPOSClient`, body).then(response => {
            if (response.status === 201) {
                dispatch(setPOSClientID(response.data.posClientID))
                dispatch(setSnackbar(true, 'success', 'POS Client Added Successfully'))
                dispatch(setModified(true))
            } else {
                dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
        })
    }
}

export const editPOSClient = (body) => {
    return function (dispatch) {
        axios.put(`${config.api.FETCH_URL}/posClient/updatePOSClient`, body).then(response => {
            if (response.status === 200) {
                dispatch(fetchPOSClient(response.data.posClientID))
                dispatch(setSnackbar(true, 'success', 'POS Client Edited Successfully'))
                dispatch(setModified(true))
            } else {
                dispatch(setSnackbar(true, 'error', 'ISO Not Modified'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
        })
    }
}

export const filteredData = (data) => {
    return function (dispatch) {
        dispatch(getFilteredData(data))
    }
}

export const submitPOSMerchantAssignment = (body) => {
    return function (dispatch) {
        axios.post(`${config.api.FETCH_URL}/posClient/assignMerchant`, body).then(response => {
            if (response.status === 200 || response.status === 201) {
                dispatch(setSnackbar(true, 'success', 'Merchant Assigned Successfully'))
                dispatch(fetchMerchantByPOSClientID(body.posClientID))
            } else {
                dispatch(setSnackbar(true, 'error', 'Merchant Assignment Failed'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Merchant Assignment Failed'))
        })
    }
}